
export default [
  {
    identifier: 'dresses-trends',
    title: 'Top Trends: Dresses Trends',
    items: [
      {
        title: 'Long & Lean',
        description: 'The <strong>slim-lined silhouette</strong> (trending at the ankle-grazing length) has the modern woman in mind.',
        image: require(`@/assets/chapters/ch2/trends/Fluid.jpg`)
      },
      {
        title: 'Animal Instinct',
        description: `From <strong>leopard to zebra</strong>, animal print dresses reigned supreme.`,
        image: require(`@/assets/chapters/ch2/trends/Animal-Prints.jpg`)
      },
      {
        title: 'New Romantics',
        description: 'Ruffled necklines, voluminous sleeves, and a hint of metallic: It’s all about dresses that bring a <strong>bit of drama</strong>.',
        image: require(`@/assets/chapters/ch2/trends/New-Romantics.jpg`)
      }
    ]
  },
  {
    identifier: 'handbags-trends',
    title: 'Top Trends: Handbags',
    items: [
      {
        title: 'Ultra Small',
        description: 'The growing trend is the <strong>shrinking size</strong>, and no one better exemplified it than Simon Porte Jacquemus who debuted Le Chiquiti, a bag the size of an index finger.',
        image: require(`@/assets/chapters/ch2/trends/The-Micro.jpg`)
      },
      {
        title: 'Retro Lady Bugs',
        description: `Structured frame bags with clip-top closures project a <strong>decidedly vintage feel</strong>.`,
        image: require(`@/assets/chapters/ch2/trends/Vintage-Frame.jpg`)
      },
      {
        title: 'New Evening',
        description: 'Chainmail, faux fur, and embellishment provided <strong>glamorous alternatives</strong> to the standard evening bag.',
        image: require(`@/assets/chapters/ch2/trends/New-Evening.jpg`)
      }
    ]
  },
  {
    identifier: 'shoes-trends',
    title: 'Top Trends: Shoes',
    items: [
      {
        title: 'Off-Duty Boots',
        description: 'Fashion meets function with all-weather, <strong>utilitarian styles</strong> such as combat and moto boots with practical soles.',
        image: require(`@/assets/chapters/ch2/trends/Off-Duty-Boots.jpg`)
      },
      {
        title: 'New Heights',
        description: '<strong>Boots to the knee</strong> and over were rendered in a variety of exotic prints as well as more classic leather.',
        image: require(`@/assets/chapters/ch2/trends/Straight-Knee-Boots.jpg`)
      },
      {
        title: 'Ladylike Glamour',
        description: 'Pumps, Mary Janes, and T-strap silhouettes returned to the runway in a <strong>play for new polish</strong>.',
        image: require(`@/assets/chapters/ch2/trends/Ladylike-Glamour.jpg`)
      }
    ]
  },
  {
    identifier: 'outerwear-trends',
    title: 'Top Trends: Outerwear',
    items: [
      {
        title: 'Faux',
        description: 'Designers and customers continued to opt for <strong>fur alternatives</strong>, found this season in ultra-luxe, cruelty-free faux fur.',
        image: require(`@/assets/chapters/ch2/trends/Faux-Fur.jpg`)
      },
      {
        title: 'Cape Town',
        description: `It's the key silhouette update for fall. The cape's timely come-back for fall will provide and <strong>easy, yet chic outerwear staple</strong>.`,
        image: require(`@/assets/chapters/ch2/trends/Cape.jpg`)
      },
      {
        title: 'New Hertiage',
        description: '<strong>Traditional fabrics</strong> from check to plaid to tweed—have been reworked and rethought.',
        image: require(`@/assets/chapters/ch2/trends/Modern-Heritage.jpg`)
      }
    ]
  },
  {
    identifier: 'accessories-trends',
    title: 'Top Trends: Accessories',
    items: [
      {
        title: 'In a Cinch',
        description: '<strong>Wide, waist-cinching belts</strong> are used to style everything from blazers to dresses.',
        image: require(`@/assets/chapters/ch2/trends/Wide-Belt.jpg`)
      },
      {
        title: 'Clip Bait',
        description: 'A nostalgic nod to the 90’s, clips and barrettes were a favorite this season, the prettiest of which came with pearls.',
        image: require(`@/assets/chapters/ch2/trends/Hair-Clip.jpg`)
      },
      {
        title: 'Headbands',
        description: 'In the long run revival, headbands continue to sweep the street and runways alike - padded for height or adorned with feathers.',
        image: require(`@/assets/chapters/ch2/trends/Headband.jpg`)
      }
    ]
  }
]
